import $ from "jquery";
import App from "../App";

const Handlebars = require('../App/Helpers/Handlebars');

const Api = (() => {
  return {
    baseUrl: 'http://portalvillach.webwerk.at/',
    geoLocation: 'Villach',
    googleMap: null,
    getCommentsUrl: function (id) {
      return Api.baseUrl + 'home/load_comments/' + id;
    },
    getReportsUrl: function () {
      return Api.baseUrl + 'home/load_pois/';
    },
    getReportUrl: function (id) {
      return Api.baseUrl + 'home/load_poi/' + id;
    },
    getReportListUrl: function () {
      return Api.baseUrl + 'home/load_pois_list/';
    },
    getAddressesUrl: function () {
      return Api.baseUrl + 'poi/load_addresses/';
    },
    getAddressFilterUrl: function () {
      return Api.baseUrl + 'home/filter_address/';
    },
    showComments: function (id, $container, $spinner, $template) {
      $container.html($spinner.html());
      $.ajax({
        url: Api.getCommentsUrl(id),
      }).done(function (response) {
        if (!App.isJSONString(response)) {
          return;
        }
        const data = JSON.parse(response);
        const compiled = Handlebars.compile($template.html())(data);
        $container.html(compiled);
      }).fail(function () {
        $container.empty();
      });
    },
    showReportList: function(status) {
      const $list = $('#poi_list');
      const $template = $('.template-poi-list');
      if($list.length <= 0 || $template.length <= 0) {
        return;
      }
      const $errorElement = $('<div/>', {
        class: 'error',
        text: 'Ein Fehler aufgetreten. Bitte versuchen Sie es zu einem späteren Zeitpunkt erneut.'
      });
      $list.addClass('loading');
      $.ajax({
        url: Api.getReportListUrl(),
        type: 'POST',
        data: {
          'status': status
        },
      }).done(function (response) {
        if (!App.isJSONString(response)) {
          return;
        }
        const data = JSON.parse(response);
        const compiled = Handlebars.compile($template.html())(data);
        $list.html(compiled);
      }).fail(function () {
        $list.append($errorElement);
      }).always(function () {
        $list.removeClass('loading');
      });
    },
    showReport: function (id) {
      const $modal = $('#report-modal');
      const $template = $modal.find('.template-content');
      const $spinner = $modal.find('.template-spinner');
      const $commentsTemplate = $modal.find('.template-comments');
      const $content = $modal.find('.modal-body');

      const onModalClosed = function () {
        $modal.addClass('loading');
        $content.empty();
        $content.html($spinner.html());
      };
      onModalClosed();
      $(window).on('hidden.bs.modal', function () {
        $(window).off('hidden.bs.modal');
        onModalClosed();
      });
      $(window).on('shown.bs.modal', function () {
        $(window).off('shown.bs.modal');
        $.ajax({
          url: Api.getReportUrl(id),
        }).done(function (response) {
          if (!App.isJSONString(response)) {
            return;
          }
          const data = JSON.parse(response);

          if (Api.googleMap !== null && typeof Api.googleMap !== 'undefined') {
            Api.googleMap.panTo(new google.maps.LatLng(data.latitude, data.longitude));
          }

          const compiled = Handlebars.compile($template.html())(data);
          $content.html(compiled);
          const $commentsContainer = $content.find('.comments-container');

          App.Api.showComments(id, $commentsContainer, $spinner, $commentsTemplate);

          $modal.removeClass('loading');
          $content.find('.slick-slider').slick({
            dots: true,
            arrows: false,
            infinite: true,
            speed: 300,
            slidesToShow: 1,
            slidesToScroll: 1,
          });
          $content.find('.slick-slider a').featherlightGallery({
            closeIcon: '×',
            previousIcon: '«',
            nextIcon: '»',
          });
          const $form = $content.find('form');
          const $submit = $form.find('input[type=submit], button[type=submit]');
          const $messages = $content.find('.form-messages');
          const $errorElement = $('<div/>', {
            class: 'error',
            text: 'Ein Fehler aufgetreten. Bitte versuchen Sie es zu einem späteren Zeitpunkt erneut.'
          });
          const $successElement = $('<div/>', {
            class: 'success',
            text: 'Vielen Dank für Ihr Kommentar.'
          });
          $form.submit(function (e) {
            e.preventDefault();
            $messages.empty();
            $submit.attr('disabled', true);
            $submit.addClass('loading');
            $.ajax({
              type: $form.attr('method'),
              url: $form.attr('action'),
              data: $form.serialize(),
            }).done(function (response) {
              if (App.isJSONString(response)) {
                const data = JSON.parse(response);
                if (data.status === 1) {
                  $messages.append($successElement);
                  $form.slideUp();
                  App.Api.showComments(id, $commentsContainer, $spinner, $commentsTemplate);
                  return;
                }
              }
              $messages.append($errorElement);
            }).fail(function () {
              $messages.append($errorElement);
            }).always(function () {
              $submit.removeClass('loading');
              $submit.attr('disabled', false);
            });
          });
        });
      });
      $modal.modal();
    }
  };
})();

module.exports = Api;
